import { type FunctionComponent, useState } from 'react';
import {
  EuiButton,
  EuiConfirmModal,
  EuiToolTip,
  useGeneratedHtmlId,
  EuiFormRow,
  EuiTextArea,
} from '@elastic/eui';
import useSuspendLogin from '@data/suspend-login';
import type { Person } from '@domain/person';

interface SuspendLoginProps {
  person: Person;
}

const SuspendLogin: FunctionComponent<SuspendLoginProps> = ({ person }) => {
  const { idnumber, firstname, surname } = person;
  const [reason, setReason] = useState('');
  const [suspendLogin, { loading }] = useSuspendLogin();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const closeModal = () => setIsModalVisible(false);
  const showModal = () => setIsModalVisible(true);
  const modalTitleId = useGeneratedHtmlId();

  const handleClick = () => {
    suspendLogin(idnumber, reason).then(() => closeModal());
  };

  return (
    <>
      <EuiToolTip content="Suspend the user's login access">
        <EuiButton
          color="danger"
          fill
          iconType="crossInCircle"
          onClick={showModal}
          isLoading={loading}>
          Suspend login
        </EuiButton>
      </EuiToolTip>

      {isModalVisible && (
        <EuiConfirmModal
          aria-labelledby={modalTitleId}
          title="Suspend login"
          titleProps={{ id: modalTitleId }}
          onCancel={closeModal}
          onConfirm={handleClick}
          cancelButtonText="Cancel"
          confirmButtonText="Suspend login"
          buttonColor="danger"
          defaultFocusedButton="confirm"
          isLoading={loading}
          confirmButtonDisabled={reason.trim() === ''}>
          <p>
            If you suspend the login account of {firstname} {surname} it will
            prevent them from logging in to any DA campaign system. This action
            can only be reversed by the Data &amp; Development team. You must
            provide a reason for suspending this login.
          </p>
          <EuiFormRow
            label="Explain the reason for suspending this login"
            fullWidth>
            <EuiTextArea
              name="reason"
              fullWidth
              isLoading={loading}
              value={reason}
              onChange={e => setReason(e.target.value)}
            />
          </EuiFormRow>
        </EuiConfirmModal>
      )}
    </>
  );
};

export default SuspendLogin;
